<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M15.576340625,13.581164662265778C15.576340625,13.581164662265778,13.063440625,11.058864662265778,13.063440625,11.058864662265778C13.722240625,10.032944662265777,14.108140625,8.818824662265778,14.108140625,7.5200046622657775C14.108140625,3.8776446622657774,11.162240625,0.9317646622657776,7.519880625,0.9317646622657776C3.877520625,0.9317646622657776,0.931640625,3.8776446622657774,0.931640625,7.5200046622657775C0.931640625,11.162364662265778,3.877520625,14.108264662265778,7.519880625,14.108264662265778C8.828110625,14.108264662265778,10.042230625,13.712964662265778,11.058740625,13.063564662265778C11.058740625,13.063564662265778,13.581040625,15.576464662265778,13.581040625,15.576464662265778C13.835140625,15.830564662265777,14.192840625,15.990564662265777,14.578740625,15.990564662265777C15.359840625,15.990564662265777,15.990440625,15.359964662265778,15.990440625,14.578864662265778C15.990440625,14.192964662265778,15.830440625,13.835264662265777,15.576340625,13.581164662265778C15.576340625,13.581164662265778,15.576340625,13.581164662265778,15.576340625,13.581164662265778ZM7.519880625,12.225864662265778C4.922230625,12.225864662265778,2.8139906249999997,10.117644662265777,2.8139906249999997,7.5200046622657775C2.8139906249999997,4.922354662265778,4.922230625,2.8141146622657773,7.519880625,2.8141146622657773C10.117520625,2.8141146622657773,12.225740625,4.922354662265778,12.225740625,7.5200046622657775C12.225740625,10.117644662265777,10.117520625,12.225864662265778,7.519880625,12.225864662265778C7.519880625,12.225864662265778,7.519880625,12.225864662265778,7.519880625,12.225864662265778Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Search',
} as DefineComponent
</script>
